import { render, staticRenderFns } from "./part3check.vue?vue&type=template&id=c8df280e&scoped=true"
import script from "./part3check.vue?vue&type=script&lang=js"
export * from "./part3check.vue?vue&type=script&lang=js"
import style0 from "./part3check.vue?vue&type=style&index=0&id=c8df280e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8df280e",
  null
  
)

export default component.exports